import type { PressItem } from './pressItems'
import styles from './PressCard.module.scss'

type PressCardProps = {
  item: PressItem
}

export const PressCard = ({ item }: PressCardProps) => (
  <a className={styles.root} href={item.href} target="_blank" rel="noopener">
    <img
      src={item.image}
      alt={`${item.outlet} · ${item.date}: ${item.headline}`}
      loading="lazy"
      decoding="async"
    />
  </a>
)
